import { apiClient, handleApiError } from './apiConfig';

// Reroute service (Path A: hours-only pay_result)
export const getRules = async (params = {}) => {
  try {
    const { data } = await apiClient.get('/reroute/rules', { params });
    return data;
  } catch (error) {
    throw new Error(handleApiError(error, 'Failed to load reroute rules'));
  }
};

export const getScenarios = async (params = {}) => {
  try {
    const { data } = await apiClient.get('/reroute/scenarios', { params });
    return data;
  } catch (error) {
    throw new Error(handleApiError(error, 'Failed to load reroute scenarios'));
  }
};

// Golden Rule: use rotation_number (business identifier), not database id
export const detectReroute = async (rotationNumber) => {
  try {
    const { data } = await apiClient.post('/reroute/detect', null, {
      params: { rotation_number: rotationNumber }
    });
    return data;
  } catch (error) {
    throw new Error(handleApiError(error, 'Failed to detect reroute'));
  }
};

export const calculate23lPay = async (rotationNumber) => {
  try {
    const { data } = await apiClient.post('/reroute/calculate', null, {
      params: { rotation_number: rotationNumber }
    });
    return data;
  } catch (error) {
    throw new Error(handleApiError(error, 'Failed to calculate §23L pay'));
  }
};

export default {
  getRules,
  getScenarios,
  detectReroute,
  calculate23lPay,
};
